
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import CancelSubscriptionDialog from './CancelSubscriptionDialog';
import ManagePaymentButton from './ManagePaymentButton';

interface SubscriptionActionsProps {
  stripeCustomerId: string | undefined;
  stripeSubscriptionId: string | undefined;
}

const SubscriptionActions: React.FC<SubscriptionActionsProps> = ({ 
  stripeCustomerId, 
  stripeSubscriptionId 
}) => {
  return (
    <div className="flex justify-between flex-wrap gap-2">
      <ManagePaymentButton stripeCustomerId={stripeCustomerId} />
      
      <div className="flex gap-2">
        <CancelSubscriptionDialog subscriptionId={stripeSubscriptionId} />
        
        <Button size="sm" asChild>
          <Link to="/subscriptions/change" className="flex items-center">
            Changer de plan
            <ArrowUpRight className="ml-1 h-4 w-4" />
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionActions;
